(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/article-components/assets/article.js') >= 0) return;  svs.modules.push('/components/tipsen/article-components/assets/article.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _svs$components$tipse = svs.components.tipsen.article.selectors,
  selectArticleIsRejected = _svs$components$tipse.selectArticleIsRejected,
  selectArticleShouldShowSkeleton = _svs$components$tipse.selectArticleShouldShowSkeleton,
  selectArticle = _svs$components$tipse.selectArticle;
const EmptyNotice = svs.component.tipsenEmptyNotice.EmptyNotice;
const fetchArticle = svs.components.tipsen.article.actions.fetchArticle;
const useArticle = articleId => {
  const article = useSelector(state => selectArticle(state, articleId));
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchArticle({
      articleId
    }));
  }, [articleId, dispatch]);
  return article;
};
const Article = _ref => {
  let className = _ref.className,
    articleId = _ref.articleId,
    _ref$noArticleMessage = _ref.noArticleMessage,
    noArticleMessage = _ref$noArticleMessage === void 0 ? 'Artikeln finns inte' : _ref$noArticleMessage;
  const isLoading = useSelector(state => selectArticleShouldShowSkeleton(state, articleId));
  const isError = useSelector(state => selectArticleIsRejected(state, articleId));
  const article = useArticle(articleId);
  const hasArticle = article === null || article === void 0 ? void 0 : article.body;
  const isEmpty = !(article !== null && article !== void 0 && article.body);
  const hasIngress = article === null || article === void 0 ? void 0 : article.ingress;
  const classNames = [];
  className && classNames.push(className);
  return React.createElement("div", {
    className: ['tipsen-article'].concat(classNames).join(' ')
  }, isLoading && 'Laddar...', isError && !hasArticle && 'Det gick inte att ladda artikeln', hasIngress &&
  React.createElement("div", {
    className: "f-content",
    dangerouslySetInnerHTML: {
      __html: article.ingress
    }
  }), hasArticle &&
  React.createElement("div", {
    className: "f-content",
    dangerouslySetInnerHTML: {
      __html: article.body
    }
  }), !isLoading && isEmpty && React.createElement(EmptyNotice, {
    branding: className
  }, noArticleMessage));
};
setGlobal('svs.components.tipsen.articleComponents.Article', Article);

 })(window);